import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
function Carousel({
  id,
  slides,
  autoScroll = false
}: {
  id: string;
  slides: string[];
  autoScroll?: boolean;
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (!autoScroll) return;
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [autoScroll, slides.length]);
  const next = () => setCurrentIndex(prev => (prev + 1) % slides.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
  return <div id={id} className="relative w-full max-w-[500px] mx-auto mb-[25px] overflow-hidden rounded-[8px] shadow-[0_4px_10px_rgba(0,0,0,0.05)]" data-id="element-254">
      <div className="flex transition-transform duration-500 ease-out" style={{
      transform: `translateX(-${currentIndex * 100}%)`
    }} data-id="element-255">
        {slides.map((src, index) => <div key={index} className="min-w-full" data-id="element-256">
            <img src={src} alt={`Slide ${index}`} className="w-full block" data-id="element-257" />
          </div>)}
      </div>
      <button onClick={prev} className="absolute top-1/2 -translate-y-1/2 left-[10px] bg-[rgba(0,0,0,0.4)] text-white border-none cursor-pointer p-[8px_12px] rounded-full z-10 text-[18px]" data-id="element-258">
        <ChevronLeft size={18} data-id="element-259" />
      </button>
      <button onClick={next} className="absolute top-1/2 -translate-y-1/2 right-[10px] bg-[rgba(0,0,0,0.4)] text-white border-none cursor-pointer p-[8px_12px] rounded-full z-10 text-[18px]" data-id="element-260">
        <ChevronRight size={18} data-id="element-261" />
      </button>
    </div>;
}
export function TestimonialCarousel() {
  const slides1 = ['https://app.heylloyd.io/public/files/openrouter-generated-image-1770583925803.png', 'https://app.heylloyd.io/public/files/openrouter-generated-image-1770583950675.png'];
  const slides2 = ['https://app.heylloyd.io/public/files/openrouter-generated-image-1770584087982.png', 'https://app.heylloyd.io/public/files/openrouter-generated-image-1770584302339.png'];
  return <section className="py-[30px] px-[15px] bg-white" data-id="element-262">
      <div className="container max-w-[700px] mx-auto px-[15px]" data-id="element-263">
        <Carousel id="carousel-1" slides={slides1} autoScroll={true} data-id="element-264" />
        <h2 className="text-[24px] text-center mb-[20px] font-[700] text-[#111827] font-['Montserrat']" data-id="element-265">
          Lo que dicen nuestros cafeteros ❤️
        </h2>
        <Carousel id="carousel-2" slides={slides2} data-id="element-266" />
      </div>
    </section>;
}